module.exports = __webpack_public_path__ + "img/logo-loader.f1bd4699.svg";